import apiClient from "./base.service";

export default {
  async index(all_events) {
    var a = all_events ? "?all=true" : "";
    return await apiClient.get(`/event${a}`);
  },
  async get(id) {
    return await apiClient.get(`/event/${id}`);
  },
  async update(id, data) {
    return await apiClient.put(`/event/${id}`, data);
  },
  async create(data) {
    return await apiClient.post(`/event`, data);
  },
  async remove(id) {
    return await apiClient.delete(`/event/${id}`);
  },
  async indexScanner(id) {
    return await apiClient.get(`/event/${id}/scanner`)
  },
  async createScanner(id, data) {
    return await apiClient.post(`/event/${id}/scanner`, data)
  },
  async removeScanner(event_id, id) {
    return await apiClient.delete(`/event/${event_id}/scanner/${id}`)
  },
  async connect(event_id, user_id, ticket_id) {
    return await apiClient.put(
      `/event/${event_id}/connect/${user_id}/${ticket_id}`
    );
  },
  async disconnect(event_id, ticket_id) {
    return await apiClient.put(`/event/${event_id}/disconnect/${ticket_id}`);
  },
  async cateringReport(event_id) {
    return await apiClient.get(`/event/${event_id}/reports/catering`);
  },
  async createBadgeExport(event_id, values) {
    return await apiClient.post(`/event/${event_id}/badge`, values);
  },
  async getBadgeExports(event_id) {
    return await apiClient.get(`/event/${event_id}/badge`);
  },
};
